import {cloneDeep} from 'lodash';

export const textFixed = ['主标题', '副标题', '按钮文案', '其他文案', '厂商名称'];
export const imageFixed = ['产品图', '背景图'];
export const ERROR_RANGE = 0.02;

export const getLastPartAfterUnderscore = key => {
    const lastKey = key.lastIndexOf('_');
    return (lastKey !== -1) ? key.substring(lastKey + 1) : '';
};

export const formatLayers = editorJson => {
    const layers = editorJson.templateData.layers;
    /**
     * 格式化参数，背景：慧图后台里layer.params[0].title字段更规范，可读性好
     */
    layers.forEach(layer => {
        if (layer.params && layer.params[0] && layer.params[0].title) {
            layer.name = layer.params[0].title;
        }
    });
    let textLayers = new Map();
    let imageLayer = new Map();

    // 用于存储文本和图像的临时数组
    let tempTextLayers = [];
    let tempImageLayer = [];
    // 用作文字图层去重
    let tempTextKeys = [];

    // 遍历layers
    for (let i = layers.length - 1; i >= 0; i--) {
        const {key, type, name, content, hidden} = layers[i];
        // 如果隐藏，则跳过
        if (hidden) {
            continue;
        }
        let newkey = `${key}_${name}`;

        if (type === 'image') {
            tempImageLayer.push({
                key: newkey,
                value: content.image
            });
        }
        else if (type === 'text') {
            !tempTextKeys.includes(key)
            && tempTextLayers.push({
                key: newkey,
                value: content.span
            });
            tempTextKeys.push(key);
        }
    }

    // 按照 textFixed 和 imageFixed 的顺序构建最终的 Map
    textFixed.forEach(textName => {
        const matchedLayer = tempTextLayers.find(layer => getLastPartAfterUnderscore(layer.key) === textName);
        matchedLayer && textLayers.set(matchedLayer.key, [matchedLayer.value.replace(/\s/g, '')]);
    });

    imageFixed.forEach(imgName => {
        const matchedLayer = tempImageLayer.find(layer => getLastPartAfterUnderscore(layer.key) === imgName);
        matchedLayer && imageLayer.set(matchedLayer.key, [{url: matchedLayer.value}]);
    });

    // 处理没有匹配上的文本层
    tempTextLayers.forEach(layer => {
        !textLayers.has(layer.key) && textLayers.set(layer.key, [layer.value.replace(/\s/g, '')]);
    });

    // 处理没有匹配上的图像层
    tempImageLayer.forEach(layer => {
        !imageLayer.has(layer.key) && imageLayer.set(layer.key, [{url: layer.value}]);
    });

    return {
        textLayers,
        imageLayer
    };
};

export const cartesianProduct = (...arrays) => {
    return arrays.reduce((acc, array) => {
        return acc.flatMap(d => array.map(e => [d, e].flat()));
    }, [[]]);
};

export const processKey = key => {
    const lastUnderscoreIndex = key.lastIndexOf('_');
    return key.substring(0, lastUnderscoreIndex);
};

export const processBatchGroupData = (batchGroupData, type) => {
    const layers = [];
    for (const key in batchGroupData) {
        if (batchGroupData.hasOwnProperty(key)) {
            let values;
            if (type === 'image') {
                values = batchGroupData[key].map(i => {
                    return i.ignore ? '' : i.url;
                });
            }
            else if (type === 'text') {
                values = batchGroupData[key]
                ?.flatMap(text => text.split('\n'))
                .filter(text => text.trim() !== '');
            }
            layers.push({
                type: type,
                key: processKey(key) + (type === 'image' ? '.image' : '.span'),
                values: values.length ? values.map(value => (value)) : ['']
            });
        }
    }
    return layers;
};

export const getByCross = (imageBatchGroupData, textBatchGroupData) => {
    const imageLayers = processBatchGroupData(imageBatchGroupData, 'image');
    const textLayers = processBatchGroupData(textBatchGroupData, 'text');
    const allLayers = [...imageLayers, ...textLayers];

    // 生成叉乘组合
    const allValues = allLayers.map(layer => layer.values);
    const cartesianResults = cartesianProduct(...allValues);
    const result = cartesianResults.map(combination => {
        const combinedLayer = {};
        combination.forEach((value, index) => {
            combinedLayer[allLayers[index].key] = value;
        });
        return combinedLayer;
    });

    return result;
};
export const getByOrderLayer = (imageBatchGroupData, textBatchGroupData) => {
    const imageLayers = processBatchGroupData(imageBatchGroupData, 'image');
    const textLayers = processBatchGroupData(textBatchGroupData, 'text');
    const allLayers = [...imageLayers, ...textLayers];
    // 找到最大数据量
    const maxLength = Math.max(...allLayers.map(layer => layer.values.length));
    // 生成最终的组合结果
    const result = [];
    for (let i = 0; i < maxLength; i++) {
        const combinedLayer = {};
        allLayers.forEach(layer => {
            if (i < layer.values.length) {
                combinedLayer[layer.key] = layer.values[i];
            }
            else {
                combinedLayer[layer.key] = layer.values[0]; // 不足时取第一条数据
            }
        });
        result.push(combinedLayer);
    }

    return result;
};

/**
 * 处理慧图图片参数
 *
 * @param templateItem 模板项
 * @param adConfig 广告配置
 * @param layers 图层
 * @returns 返回包含慧图参数的对象
 */
export function handleHuituImageParams({formData, editorJson, submitType}) {
    try {
        // formData: this.formData,
        // editorJson: this.editorJson
        let {layers, width, height} = editorJson.templateData;
        const result = changeWidthAndHeight(width, height);
        if (result.ratioText) {
            width = result.newWidth;
            height = result.newHeight;
        }
        const {imageBatchGroup, templateGroup, textBatchGroup} = formData;
        const {activeTab, chooseList = []} = templateGroup.templateGroup.template;
        let imgTplType = activeTab === 'commonTemplate' ? 'common' : 'private';
        const id = activeTab === 'commonTemplate' ? chooseList[0] : 0;
        const imageBatchGroupData = imageBatchGroup.imageBatchGroup;
        const textBatchGrouData = textBatchGroup.textBatchGroup;
        // submitType
        // 1 顺序组合：全部图层按照输入顺序依次组合，生成图片数取最大逻辑。
        // * 若最大图层数据量为a条，则生成图片为a张
        // * 其余图层不足a条数据的，取图层内第一条数据
        // 2 叉乘组合：
        // 所有图层全量叉乘，即若模版仅包含主标题、副标题、按钮文案、其他文案，且数据量分别为a、b、c、d条，则生成图片为a*b*c*d张
        // 将所有图层数据合并到一个数组中

        const adConfigList = submitType === 'byOrder'
        ? getByOrderLayer(imageBatchGroupData, textBatchGrouData)
        : getByCross(imageBatchGroupData, textBatchGrouData);

        /**
         * 格式化参数，背景：layers里的params在进入编辑器后会被丢弃，
         * layer.name里的数据不规范的话，保存为模板后，只有layer.name，无法匹配到原本的主标题、副标题等图层名称
         * 将layer.params[0].title赋值给layer.name，保证私有模板中能保留原始参数
         */
        layers.forEach(layer => {
            if (layer.params && layer.params[0] && layer.params[0].title) {
                layer.name = layer.params[0].title;
            }
        });

        const huituList = adConfigList.map(adConfigItem => {
            return {
                id,
                templateId: 0,
                productSource: 1,
                huituName: `图片工具-${getTimeStamp()}`,
                productLine: 'CHUANGYIGUAN',
                saveToMyHuitu: false,
                needMola: false,
                supportEdit: false,
                imgTplType,
                params: {
                    adConfig: adConfigItem,
                    options: {
                        result: {
                            imageType: 'jpeg',
                            type: 'URL'
                        },
                        waitUntil: 'domcontentloaded',
                        viewport: {
                            imagetTimeout: 6000,
                            width,
                            height
                        }
                    },
                    tplInfo: {
                        data: {
                            width,
                            height,
                            layers
                        },
                        previewPlugins: ['legocomponents'],
                        renderType: 'editor'
                    }
                }
            };
        });
        return huituList;
    }
    catch (error) {
        console.error(error);
    }
}

/**
 * 处理保存信息
 *
 * @param {Object} data - 数据对象
 * @param {Object} params - 参数对象
 * @returns {Object} - 返回包含基础图片信息和生成列表的对象
 */
export function handleSaveInfo(obj) {
    try {
        const {height, width, targetCount, editInfoList, ext} = obj;
        if (!editInfoList?.length) {
            return {};
        }
        return {
            basicImageInfo: {
                height,
                width,
                // 超过一定数量的话，提交给后端的targetCount使用前端实际合成的结果数；避免大量合成图片时统计数据的失败率太低
                targetCount: targetCount > 20 ? editInfoList.length : targetCount,
                imageGenerateType: 'BATCH_GEN_IMAGE',
                businessPoint: '',
                imageSubject: '',
                ext: JSON.stringify({
                    originTargetCount: targetCount,
                    ...ext
                })
            },
            risk: true,
            generateList: editInfoList.map(item => {
                const tplExt = cloneDeep(ext);
                const {url, id, editorParams, imgTplType} = item;
                if (tplExt.dataAnalysis != null) {
                    tplExt.dataAnalysis.imgTplType = imgTplType;
                }
                else {
                    if (imgTplType) {
                        tplExt.dataAnalysis = {imgTplType};
                    }
                }
                // 增加每张图的时长
                if (item.duration) {
                    tplExt.dataAnalysis.duration = item.duration;
                }
                // 增加生成的目标数和实际数
                tplExt.dataAnalysis.originTargetCount = targetCount;
                tplExt.dataAnalysis.realCount = editInfoList.length;
                const json = JSON.parse(editorParams || '{}');
                const tplData = JSON.parse(json?.tplData || '{}');
                const {width = 0, height = 0} = tplData.templateData || {};
                return {
                    url,
                    templateId: id,
                    generateJson: editorParams,
                    width,
                    height,
                    ext: JSON.stringify(tplExt)
                };
            })
        };
    }
    catch (error) {
        console.error(error);
    }
}

/**
 * 获取当前时间戳
 *
 * @returns {string} 格式为"HH:mm-yyyyMMdd"的时间字符串
 */
export function getTimeStamp() {
    const now = new Date();

    const hours = now.getHours();
    const minutes = now.getMinutes();
    const date = now.getDate();
    const month = now.getMonth() + 1;
    const year = now.getFullYear();

    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

    const formattedDate = date.toString().padStart(2, '0');
    const formattedMonth = month.toString().padStart(2, '0');

    const timeString = `${formattedHours}:${formattedMinutes}-${year}${formattedMonth}${formattedDate}`;
    return timeString;

}

export function getPreviewRenders(width, height, tplInfo) {
    let newWidth;
    let newHeight;
    if (width > height) {
        newWidth = 500;
        newHeight = parseInt(500 * height / width, 10);
    }
    else {
        newHeight = 450;
        newWidth = parseInt(450 * width / height, 10);
    }
    return [{
        width: newWidth,
        height: newHeight,
        type: 'blank',
        keyMapping: {},
        addition: {
            originColor: [],
            supportChange: 0,
            changedColor: []
        },
        template: {
            width,
            height,
            version: '1.0',
            layers: tplInfo.data.layers
        }
    }];
};

export function formatString(message, data) {
    return message.replace(/\{(\w+)\}/g, (match, key) => {
        if (data[key] != null) {
            return data[key];
        }
        return match;
    });
};

export function changeMyTemplateJson(json) {
    const result = JSON.stringify(JSON.parse(json).templateData);
    let obj = {
        templateData: result
    };
    return obj;
};

export function changeWidthAndHeight(width, height) {
    const ratio = ['16:9', '3:2', '3:4', '3:1', '9:16', '1:1'];
    let newWidth = 0;
    let newHeight = 0;
    let ratioText = '';
    ratioText = ratio.find(item => {
        let [a, b] = item.split(':');
        return (width / height) - (Number(a) / Number(b)) < ERROR_RANGE
            && (width / height) - (Number(a) / Number(b)) > -ERROR_RANGE;
    });
    // 不合规的私有模板的比例会有异常，不可重置
    // if (!ratioText) {
        // ratioText = '1:1';
    // }
    switch (ratioText) {
        case '16:9':
            newWidth = 1280;
            newHeight = 720;
            break;
        case '3:4':
            newWidth = 750;
            newHeight = 1000;
            break;
        case '3:2':
            newWidth = 1200;
            newHeight = 800;
            break;
        case '3:1':
            newWidth = 1200;
            newHeight = 400;
            break;
        case '9:16':
            newWidth = 720;
            newHeight = 1280;
            break;
        default:
            newWidth = 1000;
            newHeight = 1000;
            break;
    }
    return {newWidth, newHeight, ratioText};
}